import type { PathStage } from '~/pages/backoffice/admin/sessions/path-stages'
import type { PathStep } from '~/pages/backoffice/admin/sessions/path-step'
import { useTranslation } from 'react-i18next'
import { Input } from '~/components/ui/input'

type IProps = {
  stage: PathStage
  /** Applique une date à tout le palier — « ces trois modules le 15 », en un geste. */
  onStageDate: (steps: PathStep[], unlockAt: string) => void
  renderStep: (step: PathStep) => React.ReactNode
}

/**
 * Un palier de l'éditeur de parcours : des étapes consécutives qui ouvrent le
 * même jour (ADR 0002, D4), sous un en-tête qui en règle la date d'un coup.
 */
function PathStageGroup({ stage, onStageDate, renderStep }: IProps) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-col gap-1.5">
      {/* En-tête de palier : n'apparaît que si la vague porte plusieurs
          modules — sur un module isolé, il ferait doublon avec sa propre date. */}
      {stage.steps.length > 1 && (
        <div className="flex items-center gap-2 px-1">
          <span className="text-xs font-medium text-muted-foreground">
            {stage.unlockAt
              ? t('sessions.path.stage.on', { count: stage.steps.length })
              : t('sessions.path.stage.immediate', { count: stage.steps.length })}
          </span>
          <Input
            type="date"
            className="h-7 w-[9.5rem]"
            value={stage.unlockAt}
            onChange={e => onStageDate(stage.steps, e.target.value)}
            aria-label={t('sessions.path.stage.setDate')}
          />
        </div>
      )}
      {stage.steps.map(step => <div key={step.moduleId}>{renderStep(step)}</div>)}
    </div>
  )
}

export default PathStageGroup
